export default __webpack_public_path__ + "static/media/080_finish_bad.86f12a1f.mp4";